var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrainersActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 5.89473C10.25 5.30245 9.73458 4.83434 9.16124 4.98293C6.27313 5.73143 4.09751 8.20496 3.7879 11.25H2.5C2.08579 11.25 1.75 11.5858 1.75 12C1.75 12.4142 2.08579 12.75 2.5 12.75H3.78795C4.16101 16.414 7.23914 19.25 11 19.25C15.0192 19.25 18.25 16.0192 18.25 12C18.25 11.3918 18.1771 10.8088 18.0378 10.25H22.5C22.9142 10.25 23.25 9.91421 23.25 9.5V5.5C23.25 5.08579 22.9142 4.75 22.5 4.75H12.75C12.1977 4.75 11.75 5.19772 11.75 5.75V8.5C11.75 8.91421 11.4142 9.25 11 9.25C10.5858 9.25 10.25 8.91421 10.25 8.5V5.89473Z",
    fill: "#FD8A24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainersActive);
export default __webpack_public_path__ + "static/media/trainers-active.2d9a0acc223c0e50db19d95bc90f310b.svg";
export { ForwardRef as ReactComponent };